export const toGraphClassList = (
  classes: string | string[] | undefined,
): string[] =>
  Array.isArray(classes)
    ? classes
    : (classes?.split(/\s+/).filter(Boolean) ?? []);

export const hasGraphClass = (
  classes: string | string[] | undefined,
  className: string,
) => toGraphClassList(classes).includes(className);

export const setGraphClass = (
  classes: string | string[] | undefined,
  className: string,
  enabled: boolean,
): string[] => {
  const nextClasses = new Set(toGraphClassList(classes));

  if (enabled) nextClasses.add(className);
  else nextClasses.delete(className);

  return [...nextClasses];
};
export const BULK_LINK_PREVIEW_EDGE_CLASS = 'bulk-link-preview';
export const BULK_LINK_PREVIEW_SELECTED_EDGE_CLASS =
  'bulk-link-preview-selected';
export const BULK_LINK_TARGET_NODE_CLASS = 'bulk-link-target';
export const COLLAPSED_CLASS = 'collapsed-node';
export const UNAVAILABLE_CLASS = 'unavailable';
export const DELETED_CLASS = 'deleted';
